import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

// POST /api/movement-register — always logs the caller's own entry, dated to
// today server-side. There is no back-date field: the server ignores any
// date sent here.
export const createMovementEntryApi = ({ jobDescription, hours }) =>
  axios.post(`${API_BASE_URL}/api/movement-register`, {
    jobDescription,
    hours,
  });

// PATCH /api/movement-register/:id — correct the hours once the work is
// actually done. Job description and date can't be changed after creation.
export const updateMovementHoursApi = (id, hours) =>
  axios.patch(`${API_BASE_URL}/api/movement-register/${id}`, { hours });
